module.exports = __webpack_public_path__ + "static/media/left-medial-flexion-up.0981acdb.png";